<template>
    <div class="row">
      <div class="col-12">
        <card class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Στοιχεία Παραστατικού</h4>
            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item" role="presentation">
                <a :class="{'nav-link':true, 'active':activeStep===1, 'disabled':activeStep!==1}" id="invoice-tab-1" role="tab" aria-controls="tab1" aria-selected="true">Είδος Παραστατικού</a>
              </li>
              <li class="nav-item" role="presentation">
                <a :class="{'nav-link':true, 'active':activeStep===2, 'disabled':activeStep!==2}" id="invoice-tab-2" role="tab" aria-controls="tab2" aria-selected="false" :disabled="!invoiceInfo.wantInvoice"><span v-if="invoiceInfo.wantInvoice">ΑΦΜ&nbsp;&amp;&nbsp;</span>Χώρα</a>
              </li>
              <li class="nav-item" role="presentation" v-if="invoiceInfo.wantInvoice">
                <a :class="{'nav-link':true, 'active':activeStep===3, 'disabled':activeStep!==3}" id="invoice-tab-3" role="tab" aria-controls="tab3" aria-selected="false" :disabled="!invoiceInfo.wantInvoice">Επωνυμία</a>
              </li>
              <li class="nav-item" role="presentation" v-if="invoiceInfo.wantInvoice">
                <a :class="{'nav-link':true, 'active':activeStep===4, 'disabled':activeStep!==4}" id="invoice-tab-4" role="tab" aria-controls="tab4" aria-selected="false" :disabled="!invoiceInfo.wantInvoice">Διεύθυνση</a>
              </li>
            </ul>
            <div class="tab-content mt-3">
              <div :class="{'tab-pane':true, 'active':activeStep===1}" id="tab1" role="tabpanel" aria-labelledby="invoice-tab-1">
                <div class="form-group mt-4 text-center">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="want_invoice_input" style="width:25px;height:25px;margin-top:0;" v-model="invoiceInfo.wantInvoice">
                    <label class="form-check-label" for="want_invoice_input" style="font-size:20px;line-height:25px;margin-left:15px;">
                      Επιθυμώ Τιμολόγιο αντί για απόδειξη
                    </label>
                  </div>
                </div>
                <div class="">
                  <div class="text-center"><button class="btn btn-sm" @click="goToStep2">Επομενο&nbsp;<i class="ti-arrow-right"></i></button></div>
                </div>
              </div>
              <div :class="{'tab-pane':true, 'active':activeStep===2}" id="tab2" role="tabpanel" aria-labelledby="invoice-tab-2">
                <div class="form-group">
                  <label class="control-label" for="invoice_country_input">Χώρα</label>
                  <select class="form-control" id="invoice_country_input" v-model.trim="invoiceInfo.country">
                    <option :value="null">Επιλέξτε Χώρα</option>
                    <option :value="index" v-for="(country, index) in countries" :key="index">{{ country }}</option>
                  </select>
                </div>
                <div class="form-group" v-if="invoiceInfo.wantInvoice">
                  <label class="control-label" for="invoice_afm_input">ΑΦΜ</label>
                  <input class="form-control" id="invoice_afm_input" type="text" v-model.trim="invoiceInfo.afm">
                  <div class="text-muted">(θα γίνει έλεγχος εγκυρότητας και αυτόματη συμπλήρωση στοιχείων)</div>
                </div>
                <div class="text-center">
                  <button class="btn btn-sm mr-1" @click="goToStep1"><i class="ti-arrow-left"></i>&nbsp;Προηγουμενο</button>
                  <button v-if="invoiceInfo.wantInvoice" class="btn btn-sm ml-1" @click="goToStep3">Επομενο&nbsp;<i class="ti-arrow-right"></i></button>
                </div>
                <div v-if="checkingAfm" class="text-info text-center mt-2">Παρακαλώ περιμένετε...</div>
              </div>
              <div :class="{'tab-pane':true, 'active':activeStep===3}" id="tab3" role="tabpanel" aria-labelledby="invoice-tab-3">
                <div class="form-group">
                  <label class="control-label" for="invoice_name_input">Επωνυμία</label>
                  <input class="form-control" id="invoice_name_input" type="text" v-model.trim="invoiceInfo.name">
                </div>
                <div class="form-group">
                  <label class="control-label" for="invoice_profession_input">Επάγγελμα/Δραστηριότητα</label>
                  <input class="form-control" id="invoice_profession_input" type="text" v-model.trim="invoiceInfo.profession">
                </div>
                <div class="form-group" v-if="invoiceInfo.country==='GR'">
                  <label class="control-label" for="invoice_doy_input">ΔΟΥ</label>
                  <input class="form-control" id="invoice_doy_input" type="text" v-model.trim="invoiceInfo.doy">
                </div>
                <div class="text-center">
                  <button class="btn btn-sm mr-1" @click="goToStep2"><i class="ti-arrow-left"></i>&nbsp;Προηγουμενο</button>
                  <button class="btn btn-sm ml-1" @click="goToStep4">Επομενο&nbsp;<i class="ti-arrow-right"></i></button>
                </div>
              </div>
              <div :class="{'tab-pane':true, 'active':activeStep===4}" id="tab4" role="tabpanel" aria-labelledby="invoice-tab-4">
                <div class="form-group">
                  <label class="control-label" for="invoice_city_input">Πόλη</label>
                  <input class="form-control" id="invoice_city_input" type="text" v-model.trim="invoiceInfo.city">
                </div>
                <div class="form-group">
                  <label class="control-label" for="invoice_address_input">Διεύθυνση</label>
                  <input class="form-control" id="invoice_address_input" type="text" v-model.trim="invoiceInfo.address">
                </div>
                <div class="form-group">
                  <label class="control-label" for="invoice_postal_code_input">Ταχ. Κώδικας</label>
                  <input class="form-control" id="invoice_postal_code_input" type="text" v-model.trim="invoiceInfo.postalCode">
                </div>
                <div class="form-group">
                  <label class="control-label" for="invoice_phone_input">Τηλέφωνο</label>
                  <input class="form-control" id="invoice_phone_input" type="text" v-model.trim="invoiceInfo.phone">
                </div>
                <div class="text-center">
                  <button class="btn btn-sm" @click="goToStep3"><i class="ti-arrow-left">&nbsp;</i>Προηγουμενο</button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="text-center">
              <a href="javascript:void(0);" @click="reloadPage">ακύρωση αλλαγών</a>
              <button class="btn btn-success ml-4" v-if="activeStep===4 || (!invoiceInfo.wantInvoice && activeStep===2)" @click="saveInvoiceInfo" :disabled="savingInvoiceInfo">Αποθηκευση<span v-if="savingInvoiceInfo">...</span></button>
            </div>
          </div>
        </card>
      </div>
    </div>
</template>
<script>
import Api from "../api";
export default {
  components: {
    
  },
  data() {
    return {
      savingInvoiceInfo: false,
      invoiceInfo: {
        wantInvoice: false,
        afm: "",
        country: null,
        name: "",
        phone: "",
        address: "",
        postalCode: "",
        city: "",
        doy: "",
        profession: ""
      },
      activeStep: 1,
      countries: {},
      vatRates: {},
      latestAfmCheck: {
        afm: "",
        error: ""
      },
      checkingAfm: false
    };
  },
  mounted() {
    this.getCountries();
  },
  methods: {
    getCountries () {
      Api.send("GET", "/countries/eu", {})
        .then((response) => {
          this.countries = response;
          this.getVatRates();
        })
        .catch((err) => {
          this.$root.notifyy('danger', err.msg);
        })
        .finally(() => {
          
        });
    },
    getVatRates () {
      Api.send("GET", "/countries/vat_rates", {})
        .then((response) => {
          this.vatRates = response;
          this.getInvoiceInfo();
        })
        .catch((err) => {
          this.$root.notifyy('danger', err.msg);
        })
        .finally(() => {
          
        });
    },
    getInvoiceInfo () {
      Api.send("GET", "/user/invoice_info", {})
        .then((response) => {
          this.invoiceInfo.wantInvoice = response.data.wantInvoice;
          this.invoiceInfo.afm = response.data.afm;
          this.invoiceInfo.country = response.data.country;
          this.invoiceInfo.name = response.data.name;
          this.invoiceInfo.phone = response.data.phone;
          this.invoiceInfo.address = response.data.address;
          this.invoiceInfo.postalCode = response.data.postalCode;
          this.invoiceInfo.city = response.data.city;
          this.invoiceInfo.doy = response.data.doy;
          this.invoiceInfo.profession = response.data.profession;
        })
        .catch((err) => {
          this.$root.notifyy('danger', err.msg);
        })
        .finally(() => {
          
        });
    },
    saveInvoiceInfo () {
      if (!this.invoiceInfo.country) {
          this.$root.notifyy('danger', 'Παρακαλώ συμπληρώστε τη Χώρα');
          return false;
        }
      if (this.invoiceInfo.wantInvoice) {
          if (!this.invoiceInfo.city || this.invoiceInfo.city === "") {
            this.$root.notifyy('danger', 'Παρακαλώ συμπληρώστε την Πόλη');
            return false;
          }
          if (!this.invoiceInfo.address || this.invoiceInfo.address === "") {
            this.$root.notifyy('danger', 'Παρακαλώ συμπληρώστε τη Διεύθυνση');
            return false;
          }
          if (!this.invoiceInfo.postalCode || this.invoiceInfo.postalCode === "") {
            this.$root.notifyy('danger', 'Παρακαλώ συμπληρώστε τον Ταχ. Κώδικα');
            return false;
          }
          if (!this.invoiceInfo.phone || this.invoiceInfo.phone === "") {
            this.$root.notifyy('danger', 'Παρακαλώ συμπληρώστε το Τηλέφωνο');
            return false;
          }
        }
      this.savingInvoiceInfo = true;
      Api.send("PUT", "/user/update_invoice_info", {
        wantInvoice: this.invoiceInfo.wantInvoice, 
        afm: this.invoiceInfo.afm,
        country: this.invoiceInfo.country,
        name: this.invoiceInfo.name,
        phone: this.invoiceInfo.phone,
        address: this.invoiceInfo.address,
        postalCode: this.invoiceInfo.postalCode,
        city: this.invoiceInfo.city,
        doy: this.invoiceInfo.doy,
        profession: this.invoiceInfo.profession
      })
      .then((response) => {
        this.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        this.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        this.savingInvoiceInfo = false;
      });
    },
    goToStep1 () {
      this.activeStep = 1;
    },
    goToStep2 () {
      this.activeStep = 2;
    },
    goToStep3 () {
      if (this.activeStep < 3) {
        if (this.activeStep < 2) {
          return false;
        }
        if (!this.invoiceInfo.country) {
          this.$root.notifyy('danger', 'Παρακαλώ συμπληρώστε τη Χώρα');
          return false;
        }
        if (this.invoiceInfo.wantInvoice && (this.invoiceInfo.afm === '' || !this.invoiceInfo.afm)) {
          this.$root.notifyy('danger', 'Παρακαλώ συμπληρώστε το ΑΦΜ');
          return false;
        }

        if (this.invoiceInfo.afm === this.latestAfmCheck.afm) {
          if (this.latestAfmCheck.error && this.latestAfmCheck.error !== '') {
            this.$root.notifyy('danger', this.latestAfmCheck.error);
          } else {
            this.activeStep = 3;
          }
          return false;
        }

        if (this.checkingAfm) {
          return false;
        }

        this.checkingAfm = true;
        let self = this;
        Api.send("POST", "/user/check_afm", {
            afm: self.invoiceInfo.afm,
            country: self.invoiceInfo.country
          })
          .then((response) => {
            self.latestAfmCheck.error = "";
            self.invoiceInfo.name = response.data.invoiceInfoDto.name;
            self.invoiceInfo.phone = response.data.invoiceInfoDto.phone;
            self.invoiceInfo.address = response.data.invoiceInfoDto.address;
            self.invoiceInfo.city = response.data.invoiceInfoDto.city;
            self.invoiceInfo.postalCode = response.data.invoiceInfoDto.postalCode;
            self.invoiceInfo.doy = response.data.invoiceInfoDto.doy;
            self.invoiceInfo.profession = response.data.invoiceInfoDto.profession;
            self.activeStep = 3;
          })
          .catch((err) => {
            self.latestAfmCheck.error = err.msg;
            self.$root.notifyy('danger', err.msg);
          })
          .finally(() => {
            self.latestAfmCheck.afm = self.invoiceInfo.afm;
            self.checkingAfm = false;
          });
      } else {
        this.activeStep = 3;
      }
    },
    goToStep4 () {
      if (this.activeStep < 4) {
        if (this.activeStep < 3) {
          return false;
        }
        if (this.invoiceInfo.wantInvoice) {
          if (!this.invoiceInfo.name || this.invoiceInfo.name === "") {
            this.$root.notifyy('danger', 'Παρακαλώ συμπληρώστε την Επωνυμία');
            return false;
          }
          if (!this.invoiceInfo.profession || this.invoiceInfo.profession === "") {
            this.$root.notifyy('danger', 'Παρακαλώ συμπληρώστε το Επάγγελμα/Δραστηριότητα');
            return false;
          }
          if (this.invoiceInfo.country === "GR" && (!this.invoiceInfo.doy || this.invoiceInfo.doy === "")) {
            this.$root.notifyy('danger', 'Παρακαλώ συμπληρώστε τη ΔΟΥ');
            return false;
          }          
        }
      }
      this.activeStep = 4;
    },
    reloadPage () {
      location.reload();
    }
  },
};
</script>
<style scoped>
ul.nav-tabs li {
  cursor: pointer !important;
}
.clear {
  clear: both;
}
.pointer {
  cursor: pointer;
}
</style>
